module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 6rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("开始建设")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "一星舞蹈",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('一星', '舞蹈')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "一星技巧",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('一星', '技巧')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "二星舞蹈",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('二星', '舞蹈')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "二星技巧",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('二星', '技巧')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "三星舞蹈",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('三星', '舞蹈')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "三星技巧",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('三星', '技巧')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "四星舞蹈",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('四星', '舞蹈')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "四星技巧",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('四星', '技巧')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "五星舞蹈",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('五星', '舞蹈')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "五星技巧",
      "value": "",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.jianshe('五星', '技巧')
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79384f80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubJiansheStep1.vue
// module id = 2502
// module chunks = 0